var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhoneSvgrepoCom(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 27.009,
    height: 25.626,
    viewBox: "0 0 27.009 25.626",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "phone-svgrepo-com",
    d: "M21.439,17.147l-.633.629s-1.5,1.5-5.608-2.586-2.6-5.576-2.6-5.576l.4-.4a2.81,2.81,0,0,0,.218-3.686L11.463,3.193A2.883,2.883,0,0,0,7.141,2.8L4.961,4.966A2.941,2.941,0,0,0,4,7.2c.125,2.2,1.122,6.943,6.684,12.474,5.9,5.865,11.433,6.1,13.7,5.887a3.028,3.028,0,0,0,1.84-.93L28.2,22.671a2.861,2.861,0,0,0-.748-4.521L24.8,16.707A2.832,2.832,0,0,0,21.439,17.147Z",
    transform: "translate(-2.999 -0.998)",
    fill: "none",
    stroke: "#186aa5",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneSvgrepoCom);
export default __webpack_public_path__ + "static/media/phone-svgrepo-com.9816be23ae9227cc48174ffcfa642076.svg";
export { ForwardRef as ReactComponent };